package io.horion.cv.styles

import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import io.horion.cv.utils.Colors
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px

val CvPreviewPageStyle = CssStyle {
    base {
        Modifier
            .fillMaxSize()
            .styleModifier {
                property("display", "flex")
                property("flex-direction", "column")
                property("overflow", "hidden")
                property("box-sizing", "border-box")
            }
    }
}

val CvPreviewTopbarStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(16.px)
            .borderBottom(
                1.px,
                LineStyle.Solid,
                Colors.DarkGray
            )
    }

    Breakpoint.MD {
        Modifier.padding(18.px)
    }

    Breakpoint.LG {
        Modifier.padding(20.px)
    }
}

val CvPreviewMainContentStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .fillMaxHeight()
            .styleModifier {
                property("flex", "1")
                property("min-height", "0")
                property("overflow-y", "auto")
                property("overflow-x", "hidden")
            }
    }
}

val CvPreviewCanvasContainerStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(topBottom = 20.px)
            .styleModifier {
                property("display", "flex")
                property("justify-content", "center")
                property("align-items", "flex-start")
                property("box-sizing", "border-box")
                property("overflow", "hidden")
            }
    }

    Breakpoint.MD {
        Modifier.padding(topBottom = 30.px)
    }
}

val CvPreviewActionsStyle = CssStyle {
    base {
        Modifier
            .fillMaxWidth()
            .padding(
                top = 10.px,
                bottom = 30.px
            )
            .styleModifier {
                property("display", "flex")
                property("justify-content", "center")
                property("align-items", "center")
                property("flex-wrap", "wrap")
                property("gap", "10px")
                property("box-sizing", "border-box")
            }
    }

    Breakpoint.MD {
        Modifier.padding(
            top = 30.px,
            bottom = 50.px
        )
    }
}

val CvPreviewModifyButtonStyle = CssStyle {
    base {
        Modifier
            .height(36.px)
            .width(110.px)
            .fontSize(14.px)
            .margin(5.px)
    }

    Breakpoint.MD {
        Modifier
            .height(45.px)
            .width(145.px)
            .fontSize(18.px)
            .margin(10.px)
    }
}

val CvPreviewDownloadButtonStyle = CssStyle {
    base {
        Modifier
            .height(36.px)
            .width(160.px)
            .fontSize(14.px)
            .margin(5.px)
    }

    Breakpoint.MD {
        Modifier
            .height(45.px)
            .width(235.px)
            .fontSize(18.px)
            .margin(10.px)
    }
}

val CvPreviewActionIconStyle = CssStyle {
    base {
        Modifier
            .size(20.px)
            .margin(left = 10.px)
    }

    Breakpoint.MD {
        Modifier
            .size(24.px)
            .margin(left = 20.px)
    }
}

val CvPreviewBackButtonStyle = CssStyle {
    base {
        Modifier
            .margin(left = 10.px)
            .fontSize(12.px)
    }

    Breakpoint.MD {
        Modifier
            .margin(left = 30.px)
            .fontSize(14.px)
    }

    Breakpoint.LG {
        Modifier
            .margin(left = 95.px)
            .fontSize(16.px)
    }
}

val CvPreviewTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(12.px)
            .margin(right = 30.px)
    }

    Breakpoint.MD {
        Modifier
            .fontSize(14.px)
            .margin(right = 100.px)
    }

    Breakpoint.LG {
        Modifier
            .fontSize(16.px)
            .margin(right = 200.px)
    }
}

val CvPreviewHeaderIconStyle = CssStyle {
    base {
        Modifier.size(18.px)
    }

    Breakpoint.MD {
        Modifier.size(20.px)
    }

    Breakpoint.LG {
        Modifier.size(24.px)
    }
}

val CvPreviewThemeGroupStyle = CssStyle {
    base {
        Modifier.margin(right = 10.px)
    }

    Breakpoint.MD {
        Modifier.margin(right = 30.px)
    }

    Breakpoint.LG {
        Modifier.margin(right = 95.px)
    }
}

val CvPreviewThemeIconStyle = CssStyle {
    base {
        Modifier.fontSize(18.px)
    }

    Breakpoint.MD {
        Modifier.fontSize(25.px)
    }
}